// Marketing material content templates.
//
// Each template uses {{REFERRAL_LINK}} as a placeholder. When a partner shares
// a material, the placeholder is replaced with their actual referral link
// (e.g., https://imoney.my/ref/REF-AHM2026) so any resulting application is
// credited to that partner's commission account.

export const CONTENT_TEMPLATES = [
  {
    key: 'mbsb_personal_loan',
    label: 'MBSB Pembiayaan Peribadi',
    type: 'brochure',
    body: `Pembiayaan Peribadi MBSB
• Kadar faedah dari 3.06% setahun hingga 6.29% setahun
• Jumlah pembiayaan sehingga RM400,000
• Tempoh bayaran sehingga 10 tahun

Sesuai untuk penyatuan hutang bagi mengurangkan komitmen dengan kadar faedah tinggi kepada kadar yang lebih rendah.

Mohon sekarang: {{REFERRAL_LINK}}`,
  },
  {
    key: 'rhb_personal_loan_en',
    label: 'RHB Personal Loan (English)',
    type: 'brochure',
    body: `RHB Easy Personal Loan
• Profit rate as low as 4.99% p.a.
• Loan amount up to RM200,000
• Tenure up to 7 years
• Fast approval within 24 hours

Apply now: {{REFERRAL_LINK}}

#RHB #PersonalLoan #iMoneyMy`,
  },
  {
    key: 'rhb_credit_card_gold',
    label: 'RHB Cashback Gold Mastercard',
    type: 'poster',
    body: `🌟 RHB Cashback Gold Mastercard 🌟

✅ Up to 8% cashback on petrol & groceries
✅ No annual fee for life
✅ 0% installment plans
✅ Free travel insurance

Apply now and start earning: {{REFERRAL_LINK}}`,
  },
  {
    key: 'mbsb_home_financing',
    label: 'MBSB Home Financing-i',
    type: 'brochure',
    body: `🏠 Bina rumah impian anda dengan MBSB Home Financing-i

✓ Pembiayaan sehingga 90% nilai harta
✓ Kadar keuntungan kompetitif dari 3.85% setahun
✓ Tempoh sehingga 35 tahun
✓ Pembiayaan Islam patuh Syariah

Hubungi kami: {{REFERRAL_LINK}}`,
  },
  {
    key: 'business_loan_sme',
    label: 'SME Business Loan',
    type: 'guide',
    body: `Grow Your Business with iMoney SME Loan

💼 Loan amounts from RM50,000 to RM5 million
⏱️ Quick decision in 3 working days
📋 Minimal documentation required
💰 Use for working capital, equipment, or expansion

Get started today: {{REFERRAL_LINK}}`,
  },
  {
    key: 'general_referral',
    label: 'General Referral Promo',
    type: 'banner',
    body: `Earn rewards every time you refer a friend to iMoney! 🎁

✨ Get up to RM100 in tokens per successful referral
✨ Up to 3 levels of bonus rewards
✨ Compare 50+ banks and lenders in one place

Sign up via my link: {{REFERRAL_LINK}}`,
  },
];

// Helper to render a template body with the referral link substituted
export function renderTemplateBody(body, referralLink) {
  if (!body) return '';
  const link = referralLink || 'https://imoney.my/ref/YOURCODE';
  return body.replace(/\{\{REFERRAL_LINK\}\}/g, link);
}

// Build a referral link for a given user
export function buildReferralLink(user) {
  if (!user?.referralCode) return 'https://imoney.my/ref/YOURCODE';
  return `https://imoney.my/ref/${user.referralCode}`;
}
